export const LOGOUT = 'logout'
export const SAVE_SECTION_INFO = 'saveSectionInfo'
export const SAVE_SECTION_VALID_FLAG = 'saveSectionValidFlag'
